import { get } from '../index';

export const getAffiliations = () => {
  return get(`/affiliation/user`);
};
